"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApiShared_1 = require("../../ApiShared");
var CustomViewImpl = /** @class */ (function () {
    function CustomViewImpl(customViewModel, _registryId) {
        this._registryId = _registryId;
        this._luid = customViewModel.luid;
        this._name = customViewModel.name;
        this._shared = customViewModel.shared;
        this._isDefault = customViewModel.isDefault;
        this._ownerName = customViewModel.owner.userFriendlyName;
        this._url = customViewModel.url;
    }
    Object.defineProperty(CustomViewImpl.prototype, "luid", {
        get: function () {
            return this._luid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomViewImpl.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (name) {
            this._name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomViewImpl.prototype, "shared", {
        get: function () {
            return this._shared;
        },
        set: function (shared) {
            this._shared = shared;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomViewImpl.prototype, "isDefault", {
        get: function () {
            return this._isDefault;
        },
        set: function (isDefault) {
            this._isDefault = isDefault;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomViewImpl.prototype, "ownerName", {
        get: function () {
            return this._ownerName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomViewImpl.prototype, "url", {
        get: function () {
            return this._url;
        },
        enumerable: true,
        configurable: true
    });
    CustomViewImpl.prototype.saveAsync = function () {
        var service = ApiShared_1.ApiServiceRegistry.get(this._registryId).getService("viz-service" /* Viz */);
        return service.saveAsync(this);
    };
    return CustomViewImpl;
}());
exports.CustomViewImpl = CustomViewImpl;
//# sourceMappingURL=CustomViewImpl.js.map